import type { NextGambitDto } from '@/core/data/location/location.interface';
import { isBefore, subHours } from 'date-fns';

/** Check-in is allowed from 1h before start until gambit.end (exclusive). */
export function isInGambitCheckInWindow(start: Date | string, end: Date | string, now: Date = new Date()): boolean {
  const windowStart = subHours(new Date(start), 1);
  const windowEnd = new Date(end);
  return !isBefore(now, windowStart) && isBefore(now, windowEnd);
}

/** The confirmed gambit at a spot whose check-in window is currently open, if any. */
export function findActiveCheckInGambit(
  gambits: NextGambitDto[] | undefined | null,
  now: Date = new Date(),
): NextGambitDto | undefined {
  return gambits?.find((gambit) => gambit.isConfirmed && isInGambitCheckInWindow(gambit.start, gambit.end, now));
}
